import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-103">
      <div className="max-w-xl mx-auto space-y-3" data-id="element-104">
        <p className="text-brand-cream font-black uppercase tracking-wider" data-id="element-105">
          Programmazione Pronta™
        </p>
        <p className="text-gray-400 font-medium text-sm leading-relaxed" data-id="element-106">
          La risorsa N.1 per docenti di Informatica negli Istituti Tecnici e
          Professionali italiani. Perché insegnare Informatica non dovrebbe
          toglierti i tuoi momenti di relax.
        </p>
        <p data-id="element-107">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-108">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p className="text-xs text-gray-600" data-id="element-109">
          © Programmazione Pronta™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}